import { Action } from "@reduxjs/toolkit";
import { SearchState } from "./types";
import { isType } from "typescript-fsa";
import { searchActions } from "./actions";

const initialState: SearchState = {
    communes: [],
    district: [],
    property_type: [],
    popular_place: [],
};

export const SearchReducer = (state: SearchState = initialState, action: Action): SearchState => {
    if (isType(action, searchActions.resetToIntialState)) {
        return initialState;
    }

    if (isType(action, searchActions.getDistricts.done)) {
        return {
            ...state,
            district: action.payload.result
        }
    }

    if (isType(action, searchActions.getCommunes.done)) {
        return {
            ...state,
            communes: action.payload.result
        }
    }

    if (isType(action, searchActions.getPopularPlaces.done)) {
        return {
            ...state,
            popular_place: action.payload.result
        }
    }

    if (isType(action, searchActions.getPropertTypes.done)) {
        return {
            ...state,
            property_type: action.payload.result.map((data: { id: number; name: string; category: { id: number; name: string; } }) => ({
                value: data.id.toString(),
                label: data.name
            }))
        }
    }

    return state;
}; 